import React, { useState } from "react";
import GetYoutubeID from "lib/GetYoutubeID";
import CheckIsURL from "lib/IsValidURL";
import { popinfo } from "component/Fancybox/Fancybox";
import "./style.scss";
import { useFilePicker } from "use-file-picker";

const ExperienceMedia = (props) => {
    const [mediaType, setMediaType] = useState('image');
    const [mediaUrl, setMediaUrl]   = useState('');

    const [openFileSelector, { filesContent, plainFiles, clear }] = useFilePicker({
        readAs: 'DataURL',
        accept: ['image/png', 'image/jpg', 'image/jpeg'],
        multiple: false,
        limitFilesConfig: { max: 1 },
        maxFileSize: 2,
    });

    const ChangeMedia = (e) => {
        setMediaType(e.target.value);
    }

    const setupMediaURL = (e) => {
        setMediaUrl(e.target.value);
    }

    return (
        <form className="generic-form experience-media-form" onSubmit={e => {
            e.preventDefault();

            let FileURL;

            if(mediaType === 'image')
            {
                if(!filesContent.length)
                {
                    return popinfo('error', 'Add Media', 'Choose image that you want to use');
                }

                FileURL = filesContent[0].content;
            }
            else if(mediaType == 'youtube')
            {
                if(!mediaUrl)
                {
                    return popinfo('error', 'Add Media', 'Please enter the Youtube URL');
                }

                let YoutubeID = GetYoutubeID(mediaUrl);

                if(!YoutubeID)
                {
                    return popinfo('error', 'Add Media', 'Invalid Youtube URL');
                }

                FileURL = mediaUrl;
            }
            else
            {
                if(!mediaUrl)
                {
                    return popinfo('error', 'Add Media', 'Please enter the website / page URL');
                }

                if(!CheckIsURL(mediaUrl))
                {
                    return popinfo('error', 'Add Media', 'Invalid Website / Page URL, please make sure it starting with http / https');
                }

                FileURL = mediaUrl;
            }

            props.onSaved({
                ExpMediaType        : mediaType
                ,ExpMediaURL        : FileURL
                ,ExpMediaName       : filesContent && filesContent.length > 0 ? filesContent[0].name : ''
                ,isDeleted          : 0
                ,ExpMediaOrder      : 0
            });
        }}>
            <label >
                <input type="radio" name="media-type" value="image" checked={mediaType === 'image'} onChange={ChangeMedia} />
                Image
            </label>
            <label >
                <input type="radio" name="media-type" value="youtube" checked={mediaType === 'youtube'} onChange={ChangeMedia} />
                Youtube
            </label>
            <label >
                <input type="radio" name="media-type" value="website" checked={mediaType === 'website'} onChange={ChangeMedia} />
                Website / Page
            </label>
            <div className="media-uploader">
                {
                    mediaType === "website" &&
                    <input className="form-control text" placeholder="Add your website / page url" onChange={setupMediaURL}/>
                }
                {
                    mediaType === "youtube" &&
                    <input className="form-control text" placeholder="Put your Youtube Video URL" onChange={setupMediaURL}/>
                }
                {
                    mediaType === "image" &&
                    <span className="image-box image-uploader-box">
                        {
                            filesContent.length > 0 && 
                                <img alt={filesContent[0].name} src={filesContent[0].content}></img>
                        }
                        <a href="#" className="btn btn-mini btn-orange" onClick={(e) => {
                            e.preventDefault();

                            openFileSelector();

                        }}>Change Image</a>
                    </span>
                }
                <div className="text-right mt-md">
                    <input type="submit" className="btn btn-small btn-primary" value="Add" />
                </div>
            </div>
        </form>
    )
}

export default ExperienceMedia;